<div class="row  justify-content-around" *ngIf="isMobileDivice; else mobile">
  <div class="col-sm-11">
    <div class="row justify-content-around menu-list">

      <div class="col-lg-3 col-md-3" *ngFor="let service of getServices(_servicesList)">
        <!-- <p>{{service |json}}</p> -->
        <button (click)="clickEvent(service)" class="primary-color" [color]="service.routingData ==  seletedService ? 'primary' : ''"
          (click)="toggle(service.id);" class="row" mat-raised-button class="button-menu">
          <div class=" row button-content">
            <div class="row">
              <div class="col-sm-2 col-md-3 col-lg-3 ">
                <div class="icon-bg">
                  <!-- //// -->
                  <mat-icon  style="height:100%; width:100%;" svgIcon="{{service.ImageMenuSrc}}"></mat-icon>
                 
                </div>
              </div>
              <div class="col-sm-10  col-md-9 col-lg-9">
                 <!-- Default ====================================================================================-->
                <h3 *ngIf="service.menuTitle ==='Je réserve un véhicule' && siteType === 'default'" class="mr-2">
                  {{ 'SEARCH.BOUTONAUTOPARTAGE' | translate }}
                </h3>
                <h3 *ngIf="service.menuTitle ==='Je recharge mon véhicule' && siteType === 'default'" class="mr-2">
                  {{ 'SEARCH.BOUTONRECHARGE' | translate }}
                </h3>
                <h3 *ngIf="service.menuTitle ==='Je réserve un vélo' && siteType === 'default'" class="mr-2">
                  {{ 'SEARCH.BOUTONVELO' | translate }}
                </h3>
                <h3 *ngIf="service.menuTitle ==='Je covoiture' && siteType === 'default'" class="mr-2">
                  {{ 'SEARCH.BOUTONTRAJET' | translate }}
                </h3>

                <!-- mamSncf ====================================================================================-->
                <h3 *ngIf="service.menuTitle ==='Je réserve un véhicule' && siteType === 'mam'" class="mr-2">
                  AutoMAM
                </h3>
                <h3 *ngIf="service.menuTitle ==='Je réserve un vélo' && siteType === 'mam'" class="mr-2">
                  CycloMAM
                </h3>
                <h3 *ngIf="service.menuTitle ==='Je covoiture' && siteType === 'mam'" class="mr-2">
                  Covoiturage
                </h3>

                 <!-- Remi ====================================================================================-->
                <h3 *ngIf="service.menuTitle ==='Je réserve un véhicule' && siteType === 'remi'" class="mr-2">
                  Autopartage
                </h3>
                <h3 *ngIf="service.menuTitle ==='Je recharge mon véhicule' && siteType === 'remi'" class="mr-2">
                    Recharge 
                  </h3>
                <h3 *ngIf="service.menuTitle ==='Je covoiture' && siteType === 'remi'" class="mr-2">
                  Covoiturage
                </h3>

              </div>
             <!-- fff -->
            </div>
          </div>
        </button>

      </div>


    </div>
  </div>
</div>
<ng-template #mobile>
  <div class="row">
    <div class="col-sm-12">
      <div class="row justify-content-around menu-list">
        <div class="col-4" *ngFor="let service of getServices(_servicesList)">
          <button (click)="clickEvent(service)" [color]="service.routingData ==  seletedService ? 'primary' : ''"
            (click)="toggle(service.id);" class="row" mat-raised-button class="button-menu">
            <div class=" row button-content">
              <div class="row justify-content-center">
                <div class="col-10 col-md-3 col-lg-3 ">
                  <div class="icon-bg">
                    <mat-icon style="height:40px; width:40px;" svgIcon="{{service.ImageMenuSrc}}"></mat-icon>
                  </div>
                </div>
                <!-- <div class="col-8  col-md-9 col-lg-9">

                   <!-- Default ====================================================================================-->
                  <!-- <h3 *ngIf="service.menuTitle ==='Je réserve un véhicule' && siteType === 'default'" class="mr-2">
                    {{ 'SEARCH.BOUTONAUTOPARTAGE' | translate }}
                  </h3>
                  <h3 *ngIf="service.menuTitle ==='Je recharge mon véhicule' && siteType === 'default'" class="mr-2">
                    {{ 'SEARCH.BOUTONRECHARGE' | translate }}
                  </h3>
                  <h3 *ngIf="service.menuTitle ==='Je réserve un vélo' && siteType === 'default'" class="mr-2">
                    {{ 'SEARCH.BOUTONVELO' | translate }}
                  </h3>
                  <h3 *ngIf="service.menuTitle ==='Je covoiture' && siteType === 'default'" class="mr-2">
                    {{ 'SEARCH.BOUTONTRAJET' | translate }}
                  </h3> -->

                  <!-- mamSncf ====================================================================================-->
                  <!-- <h3 *ngIf="service.menuTitle ==='Je réserve un véhicule' && siteType === 'mam'" class="mr-2">
                    AutoMAM
                  </h3>
                  <h3 *ngIf="service.menuTitle ==='Je réserve un vélo' && siteType === 'mam'" class="mr-2">
                    CycloMAM
                  </h3>
                  <h3 *ngIf="service.menuTitle ==='Je covoiture' && siteType === 'mam'" class="mr-2">
                    Covoiturage
                  </h3> -->

                  <!-- Remi ====================================================================================-->
                  <!-- <h3 *ngIf="service.menuTitle ==='Je réserve un véhicule' && siteType === 'remi'" class="mr-2">
                    Autopartage
                  </h3>
                   <h3 *ngIf="service.menuTitle ==='Je recharge mon véhicule' && siteType === 'remi'" class="mr-2">
                    Recharge 
                  </h3>
                  <h3 *ngIf="service.menuTitle ==='Je covoiture' && siteType === 'remi'" class="mr-2">
                    Covoiturage
                  </h3> 

                </div> -->
              </div>
            </div>
          </button>

        </div>


      </div>
    </div>

  </div>
</ng-template>
